(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nv-categories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nv-categories'))customElements.define('nv-categories',class extends HTMLElement{
  connectedCallback(){
    if(this.initialized)return;
    this.initialized=true;
    this.cards=[...this.querySelectorAll('[data-card]')];
    this.index=Math.floor(this.cards.length/2);
    this.dataset.enhanced='true';
    this.addEventListener('click',e=>{
      if(this.suppressClickUntil>performance.now()){e.preventDefault();return}
      const button=e.target.closest('[data-direction]');
      if(button)this.go(this.index+Number(button.dataset.direction));
      const card=e.target.closest('[data-card]');
      if(card&&this.cards.indexOf(card)!==this.index){e.preventDefault();this.go(this.cards.indexOf(card))}
    });
    this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1))}});
    this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('[data-card]');if(card)this.go(this.cards.indexOf(card))});
    let startX=0,startY=0;
    this.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY},{passive:true});
    this.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-startX,vertical=e.changedTouches[0].clientY-startY;if(Math.abs(delta)>45&&Math.abs(delta)>Math.abs(vertical)){this.suppressClickUntil=performance.now()+350;this.go(this.index+(delta<0?1:-1))}},{passive:true});
    this.go(this.index);
  }
  go(index){
    const count=this.cards.length;
    if(!count)return;
    this.index=(index+count)%count;
    this.cards.forEach((card,i)=>{
      let offset=i-this.index;
      if(offset>count/2)offset-=count;
      if(offset< -count/2)offset+=count;
      const distance=Math.abs(offset);
      card.style.setProperty('--offset',offset);
      card.style.setProperty('--scale',Math.max(.64,1-distance*.12));
      card.style.setProperty('--layer',10-distance);
      card.style.setProperty('--opacity',distance>2?0:1);
      card.toggleAttribute('data-active',distance===0);
      card.inert=distance>2;
      card.setAttribute('aria-current',distance===0?'true':'false');
    });
    const label=this.querySelector('[data-count]');
    if(label)label.textContent=`${this.index+1} / ${count}`;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-collection"]) return;
  try {
    
if(!window.nvFiltersBound){window.nvFiltersBound=true;document.addEventListener('change',event=>{if(event.target.matches('[data-nvc-sort]'))event.target.form.requestSubmit()});document.addEventListener('submit',event=>{if(!event.target.matches('[data-nvc-filter-form]'))return;event.target.querySelectorAll('input[type="number"]').forEach(input=>{if(input.value==='')input.disabled=true})});document.addEventListener('click',event=>{const close=event.target.closest('[data-nvc-close]');if(close){const parent=close.closest('details');parent.removeAttribute('open');parent.querySelector('summary').focus()}document.querySelectorAll('.nvc-filter[open]').forEach(details=>{if(!details.contains(event.target))details.removeAttribute('open')})});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.nvc-filter[open]').forEach(details=>{details.removeAttribute('open');details.querySelector('summary').focus()})});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-featured"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nv-featured'))customElements.define('nv-featured',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;this.tabs=[...this.querySelectorAll('[data-tab]')];this.panels=[...this.querySelectorAll('[data-panel]')];this.active=0;this.positions=this.panels.map(()=>0);this.dataset.enhanced='true';this.addEventListener('click',e=>{if(this.suppressClickUntil>performance.now()){e.preventDefault();return}const tab=e.target.closest('[data-tab]');if(tab)this.select(Number(tab.dataset.tab));const button=e.target.closest('[data-direction]');if(button)this.go(this.positions[this.active]+Number(button.dataset.direction));const slide=e.target.closest('[data-product]');if(slide&&!slide.hasAttribute('data-active')){e.preventDefault();this.go([...this.panels[this.active].querySelectorAll('[data-product]')].indexOf(slide))}});this.addEventListener('keydown',e=>{const tab=e.target.closest('[data-tab]');if(tab&&['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const index=e.key==='Home'?0:e.key==='End'?this.tabs.length-1:(this.active+(e.key==='ArrowRight'?1:-1)+this.tabs.length)%this.tabs.length;this.select(index);this.tabs[index].focus()}});this.addEventListener('shopify:block:select',e=>{const tab=e.target.closest('[data-tab]');if(tab)this.select(Number(tab.dataset.tab))});let startX=0,startY=0;this.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY},{passive:true});this.addEventListener('touchend',e=>{if(e.target.closest('[data-tab]'))return;const delta=e.changedTouches[0].clientX-startX,vertical=e.changedTouches[0].clientY-startY;if(Math.abs(delta)>45&&Math.abs(delta)>Math.abs(vertical)){this.suppressClickUntil=performance.now()+350;this.go(this.positions[this.active]+(delta<0?1:-1))}},{passive:true});this.select(0)}select(index){this.active=index;this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',i===index?'true':'false');tab.tabIndex=i===index?0:-1});this.panels.forEach((panel,i)=>{panel.hidden=i!==index});this.go(this.positions[index])}go(index){const panel=this.panels[this.active];if(!panel)return;const slides=[...panel.querySelectorAll('[data-product]')],count=slides.length;if(!count)return;this.positions[this.active]=(index+count)%count;slides.forEach((slide,i)=>{let offset=i-this.positions[this.active];if(offset>count/2)offset-=count;if(offset< -count/2)offset+=count;const distance=Math.abs(offset);slide.style.setProperty('--offset',offset);slide.style.setProperty('--scale',Math.max(.58,1-distance*.15));slide.style.setProperty('--layer',10-distance);slide.style.setProperty('--opacity',distance>2?0:1);slide.toggleAttribute('data-active',distance===0);slide.inert=distance>2;const details=slide.querySelector('.nv-featured__details');if(details)details.inert=distance!==0});const label=panel.querySelector('[data-count]');if(label)label.textContent=`${this.positions[this.active]+1} / ${count}`;panel.querySelectorAll('[data-direction]').forEach(button=>button.disabled=count<2)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-header"]) return;
  try {
    
  if (!customElements.get('nv-header')) {
    customElements.define('nv-header', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-nv-dialog-open]');
          if (opener) {
            const dialog = document.getElementById(opener.dataset.nvDialogOpen);
            if (dialog && !dialog.open) { dialog.showModal(); document.documentElement.classList.add('nv-modal-open'); }
          }
          const closer = event.target.closest('[data-nv-dialog-close]');
          if (closer) closer.closest('dialog').close();
        });
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('close', () => document.documentElement.classList.remove('nv-modal-open'));
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const box = dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
          });
        });
        this.querySelectorAll('.nv-desktop-nav__details').forEach(details => {
          details.addEventListener('toggle', () => {
            if (!details.open) return;
            this.querySelectorAll('.nv-desktop-nav__details').forEach(other => { if (other !== details) other.open = false; });
          });
        });
        this.outsideHandler = event => {
          if (!this.contains(event.target)) this.querySelectorAll('.nv-desktop-nav details[open]').forEach(details => { details.open = false; });
        };
        this.escapeHandler = event => {
          if (event.key === 'Escape') this.querySelectorAll('.nv-desktop-nav details[open]').forEach(details => { details.open = false; });
        };
        document.addEventListener('click', this.outsideHandler);
        this.addEventListener('keydown', this.escapeHandler);
      }
      disconnectedCallback() { document.removeEventListener('click', this.outsideHandler);this.removeEventListener('keydown', this.escapeHandler);this.initialized = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nv-hero'))customElements.define('nv-hero',class extends HTMLElement{
  connectedCallback(){
    if(this.initialized)return;
    this.initialized=true;
    this.slides=[...this.querySelectorAll('[data-slide]')];
    this.index=0;
    this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.addEventListener('click',e=>{
      if(this.suppressClickUntil>performance.now()){e.preventDefault();return}
      const direction=e.target.closest('[data-direction]');
      if(direction){this.go(this.index+Number(direction.dataset.direction));this.restart()}
      const pause=e.target.closest('[data-pause]');
      if(pause){this.paused=!this.paused;this.updatePause();this.restart()}
    });
    this.addEventListener('mouseenter',()=>{this.hovered=true;this.stop()});
    this.addEventListener('mouseleave',()=>{this.hovered=false;this.restart()});
    this.addEventListener('focusin',()=>{this.focused=true;this.stop()});
    this.addEventListener('focusout',e=>{this.focused=this.contains(e.relatedTarget);this.restart()});
    this.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-slide]');if(slide){this.go(this.slides.indexOf(slide));this.paused=true;this.updatePause();this.stop()}});
    this.visibilityHandler=()=>this.restart();
    document.addEventListener('visibilitychange',this.visibilityHandler);
    let startX=0,startY=0;
    this.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY},{passive:true});
    this.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-startX,vertical=e.changedTouches[0].clientY-startY;if(Math.abs(delta)>50&&Math.abs(delta)>Math.abs(vertical)){this.suppressClickUntil=performance.now()+350;this.go(this.index+(delta<0?1:-1));this.restart()}},{passive:true});
    this.updatePause();this.restart();
  }
  go(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{const active=i===this.index;slide.hidden=!active;slide.inert=!active;slide.classList.toggle('is-active',active)});const counter=this.querySelector('[data-current]');if(counter)counter.textContent=this.index+1}
  updatePause(){const button=this.querySelector('[data-pause]');if(button){button.setAttribute('aria-label',this.paused?button.dataset.playLabel:button.dataset.pauseLabel);button.firstElementChild.textContent=this.paused?'▷':'Ⅱ'}}
  stop(){clearInterval(this.timer)}
  restart(){this.stop();if(this.dataset.autoplay==='true'&&!this.paused&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setInterval(()=>this.go(this.index+1),Number(this.dataset.speed)||8000)}
  disconnectedCallback(){this.stop();document.removeEventListener('visibilitychange',this.visibilityHandler)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const requests = new WeakMap();
    document.addEventListener('click', async (event) => {
      const mediaButton = event.target.closest('[data-nv-media-button]');
      if (mediaButton) {
        const gallery = mediaButton.closest('[data-nv-gallery]');
        gallery.querySelectorAll('[data-nv-media]').forEach((media) => {
          const isSelected = media.dataset.nvMedia === mediaButton.dataset.nvMediaButton;
          media.hidden = !isSelected;
          if (!isSelected) media.querySelectorAll('video').forEach((video) => video.pause());
        });
        gallery.querySelectorAll('[data-nv-media-button]').forEach((button) => button.setAttribute('aria-pressed', String(button === mediaButton)));
      }
      const quantityButton = event.target.closest('[data-nv-product-quantity]');
      if (quantityButton) {
        const input = quantityButton.parentElement.querySelector('input');
        if (Number(quantityButton.dataset.nvProductQuantity) > 0) input.stepUp(); else input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const copyButton = event.target.closest('[data-nv-copy-link]');
      if (copyButton) {
        const input = copyButton.parentElement.querySelector('input');
        input.select();
        try { await navigator.clipboard.writeText(input.value); copyButton.textContent = copyButton.dataset.copied; } catch (_) { input.focus(); }
      }
    });
    document.addEventListener('change', async (event) => {
      const option = event.target.closest('[data-nv-option]');
      if (!option) return;
      const product = option.closest('[data-nv-product]');
      requests.get(product)?.abort();
      const controller = new AbortController();
      requests.set(product, controller);
      const quantity = product.querySelector('input[name="quantity"]')?.value;
      const activeId = option.id;
      const values = Array.from(product.querySelectorAll('[data-nv-option]:checked'), (input) => input.dataset.optionValueId);
      const requestUrl = new URL(option.dataset.productUrl || product.dataset.productUrl, location.origin);
      const currentUrl = new URL(location.href);
      ['preview_theme_id', '_fd', 'pb', 'view'].forEach((key) => { if (currentUrl.searchParams.has(key)) requestUrl.searchParams.set(key, currentUrl.searchParams.get(key)); });
      requestUrl.searchParams.set('section_id', product.dataset.sectionId);
      requestUrl.searchParams.set('option_values', values.join(','));
      product.setAttribute('aria-busy', 'true');
      product.querySelector('button[name="add"]').disabled = true;
      product.querySelector('input[name="id"]').disabled = true;
      product.querySelector('.nv-product__express')?.setAttribute('inert', '');
      const error = product.querySelector('[data-nv-variant-error]');
      if (error) error.textContent = '';
      try {
        const response = await fetch(requestUrl.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error('Variant response failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextProduct = html.querySelector('[data-nv-product]');
        if (!nextProduct) throw new Error('Product section missing');
        if (controller.signal.aborted) return;
        const sameProduct = nextProduct.dataset.productUrl === product.dataset.productUrl;
        if (sameProduct) {
          product.querySelector('[data-nv-product-info]').replaceWith(nextProduct.querySelector('[data-nv-product-info]'));
          const nextSelectedMedia = nextProduct.querySelector('[data-nv-media-button][aria-pressed="true"]');
          if (nextSelectedMedia) product.querySelector(`[data-nv-media-button="${nextSelectedMedia.dataset.nvMediaButton}"]`)?.click();
        } else {
          product.innerHTML = nextProduct.innerHTML;
          product.dataset.productUrl = nextProduct.dataset.productUrl;
        }
        const quantityInput = product.querySelector('input[name="quantity"]');
        if (quantityInput && quantity) {
          quantityInput.value = quantity;
          if (!quantityInput.checkValidity()) quantityInput.value = quantityInput.min || '1';
        }
        const newVariant = product.querySelector('input[name="id"]')?.value;
        const pageUrl = new URL(requestUrl);
        pageUrl.searchParams.delete('section_id');
        if (newVariant) { pageUrl.searchParams.delete('option_values'); pageUrl.searchParams.set('variant', newVariant); }
        history.replaceState({}, '', pageUrl.pathname + pageUrl.search);
        product.querySelector(`#${CSS.escape(activeId)}`)?.focus({ preventScroll: true });
        if (window.Shopify?.PaymentButton) window.Shopify.PaymentButton.init();
        product.dispatchEvent(new CustomEvent('nv:variant-change', { bubbles: true, detail: { variantId: newVariant } }));
      } catch (failure) {
        if (failure.name !== 'AbortError') {
          const message = product.querySelector('[data-nv-variant-error]');
          if (message) message.textContent = product.dataset.variantError;
          product.querySelector('input[name="id"]').disabled = true;
        }
      } finally {
        if (requests.get(product) === controller) { product.removeAttribute('aria-busy'); requests.delete(product); }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-search"]) return;
  try {
    
if(!window.nvFiltersBound){window.nvFiltersBound=true;document.addEventListener('change',event=>{if(event.target.matches('[data-nvc-sort]'))event.target.form.requestSubmit()});document.addEventListener('submit',event=>{if(!event.target.matches('[data-nvc-filter-form]'))return;event.target.querySelectorAll('input[type="number"]').forEach(input=>{if(input.value==='')input.disabled=true})});document.addEventListener('click',event=>{const close=event.target.closest('[data-nvc-close]');if(close){const parent=close.closest('details');parent.removeAttribute('open');parent.querySelector('summary').focus()}document.querySelectorAll('.nvc-filter[open]').forEach(details=>{if(!details.contains(event.target))details.removeAttribute('open')})});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.nvc-filter[open]').forEach(details=>{details.removeAttribute('open');details.querySelector('summary').focus()})});}

  } catch(e) { console.error(e); }
})();
})();
